exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.calendar-icon {\n  font-size: 39px;\n  position: absolute;\n  margin-left: -22px;\n  z-index: 2;\n  color: #848383;\n}\n\n.spinner-container {\n  padding: 100px;\n  min-height: 300px;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  text-align: center;\n}\n\n.loader {\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #3498db;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  animation: spin 0.5s linear infinite;\n  margin: auto;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/shared/wait-spinner/wait-spinner.component.css
// module id = 955
// module chunks = 3